import { PermissionAction, PermissionResource } from '@entities/tenant/permission';

import { requirePermission } from '../../../require-permission';

export const checkoutLoader = requirePermission(
  PermissionResource.MachineOrders,
  PermissionAction.Write,
);
